import React from 'react';

export const SnackbarContext = React.createContext({
    msg: '',
    isDisplayed: false,
    severity: '',
    displayMsg: (_msg) => { },
    onClose: () => { },
});
